import {
  Avatar, Button, Card,
  CardContent, CardHeader, Container, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, fade,
  FormControl, Grid, InputAdornment, InputLabel, LinearProgress, MenuItem, Paper, Select, TextField
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import DashboardRoundedIcon from "@material-ui/icons/DashboardRounded";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import FavoriteOutlinedIcon from "@material-ui/icons/FavoriteOutlined";
import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import { firestore } from "firebase";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import AppBar from "../components/AppBar";
import { db } from "../firebase";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: 50,
  },
  paper: {
    textAlign: "center",
    padding: 40,
    marginTop: 50,
    transition: "0.3s ease-in-out",
    "&:hover": {
      backgroundColor: fade(theme.palette.common.black, 0.1),
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
  },
  avatar: {
    height: 50,
    width: 50,
    backgroundColor: red[500],
  },
  link: {
    textDecoration: "none",
  },
}));

function Profile() {
  const classes = useStyles();
  const email = useAuth().currentUser.email;

  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    favorites: [],
    cart: [],
    orders: [],
    phone: "",
    age: 0,
    gender: "U",
    tomcoins: 0,
    address: "",
  });

  function getUserData() {
    db.collection("userData")
      .doc(email)
      .onSnapshot((snapshot) => {
        console.log("GET");
        setValues(snapshot.data());
      });
  }

  useEffect(() => {
    getUserData();
  }, []);

  const [openDialog, setOpenDialog] = React.useState(false);
  const handleDialogClickOpen = () => {
    setOpenDialog(true);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const [updating, setUpdating] = useState(false);

  function updateProfile() {
    setUpdating(true);
    db.collection("userData")
      .doc(email)
      .update({
        firstName: values.firstName,
        lastName: values.lastName,
        age: values.age,
        gender: values.gender,
        address: values.address,
        phone: values.phone,
      })
      .then(() => {
        console.log("SUCCESS");
        setUpdating(false);
      });
  }

  function AlertDialog() {
    const [values, setValues] = useState();

    function addMoney() {
      db.collection("userData")
        .doc(email)
        .update({ tomcoins: firestore.FieldValue.increment(Number(values)) });
    }

    return (
      <div>
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Add tomcoins to your wallet
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography>How many coins would you like to add?</Typography>
              <TextField
                value={values}
                onChange={(event) => {
                  setValues(event.target.value);
                }}
                margin="normal"
                id="standard-basic"
                placeholder="Add tomcoins"
                fullWidth
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="secondary">
              Close
            </Button>
            <Button
              onClick={() => {
                addMoney();
                setOpenDialog(false);
              }}
              color="primary"
              autoFocus
            >
              Add & Continue
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  return (
    <>
      <AppBar />
      <AlertDialog />
      <Container>
        <Card variant="outlined" className={classes.root}>
          <CardHeader
            avatar={
              <Avatar aria-label="recipe" className={classes.avatar}>
                {values.firstName[0]}
              </Avatar>
            }
            title={
              <Typography variant="h3">
                {values.firstName + " " + values.lastName}
              </Typography>
            }
            subheader={
              <Typography style={{ marginLeft: 5 }}>{email}</Typography>
            }
            action={
              <div>
                <Typography
                  style={{ textAlign: "right", padding: 5 }}
                  variant="h6"
                >
                  {`Rs. ${values.tomcoins}`}
                </Typography>
                <Button
                  color="secondary"
                  variant="text"
                  onClick={handleDialogClickOpen}
                  startIcon={<AccountBalanceWalletIcon />}
                >
                  Add tomcoins
                </Button>
              </div>
            }
          />
          <CardContent>
            <Container>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Link to="/favorites" className={classes.link}>
                    <Paper variant="outlined" className={classes.paper}>
                      <Typography
                        variant="h5"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <FavoriteOutlinedIcon
                          color="secondary"
                          style={{ marginRight: 10 }}
                        />
                        {values.favorites.length}
                      </Typography>
                      <Typography variant="body1">favorites</Typography>
                    </Paper>
                  </Link>
                </Grid>
                <Grid item xs={4}>
                  <Link to="/cart" className={classes.link}>
                    <Paper variant="outlined" className={classes.paper}>
                      <Typography
                        variant="h5"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <LocalMallIcon
                          color="secondary"
                          style={{ marginRight: 10 }}
                        />
                        {values.cart.length}
                      </Typography>
                      <Typography variant="body1">items in cart</Typography>
                    </Paper>
                  </Link>
                </Grid>
                <Grid item xs={4}>
                  <Link to="/orders" className={classes.link}>
                    <Paper variant="outlined" className={classes.paper}>
                      <Typography
                        variant="h5"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <DashboardRoundedIcon
                          color="secondary"
                          style={{ marginRight: 10 }}
                        />
                        {values.orders.length}
                      </Typography>
                      <Typography variant="body1">orders</Typography>
                    </Paper>
                  </Link>
                </Grid>
              </Grid>

              <Grid container spacing={2} style={{ marginTop: 20 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="firstName"
                    label="First name"
                    id="firstName"
                    onChange={handleChange("firstName")}
                    value={values.firstName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DateRangeOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="lastName"
                    label="Last name"
                    id="lastName"
                    onChange={handleChange("lastName")}
                    value={values.lastName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DateRangeOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} style={{ marginTop: 10 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="age"
                    label="Age"
                    id="age"
                    value={values.age}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DateRangeOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel id="demo-simple-select-outlined-label">
                      Gender
                    </InputLabel>
                    <Select
                      value={values.gender}
                      onChange={handleChange("gender")}
                      label={"Gender"}
                    >
                      <MenuItem value={"M"}>Male</MenuItem>
                      <MenuItem value={"F"}>Female</MenuItem>
                      <MenuItem value={"U"}>Prefer not to say</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="phone"
                    onChange={handleChange("phone")}
                    label="Phone"
                    value={values.phone}
                    id="phone"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PhoneOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    multiline
                    fullWidth
                    name="address"
                    onChange={handleChange("address")}
                    label="Address"
                    value={values.address}
                    id="address"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <BusinessOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  {updating && <LinearProgress color="secondary" />}
                </Grid>
                <Grid item xs={6} sm={9} />
                <Grid item xs={6} sm={3}>
                  <Button
                    fullWidth
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                      updateProfile();
                    }}
                  >
                    Update profile
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}

export default Profile;
